import {ComponentRegistry} from '../../components/component-registry';
import {DataApi} from '../../api/data-api/data-api';
import {AbstractFilter} from '../abstract-filter';
import {PluginFilter, PluginSettings} from '../abstract-data-api-plugin';

interface PublicationFilter extends PluginFilter {
}

interface PublicationSettings extends PluginSettings {
}

export {PublicationFilter, PublicationSettings};

/**
 * Publication filter.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class Filter extends AbstractFilter<PublicationFilter, PublicationSettings> {
  constructor(container: HTMLElement) {
    super(container, 'publication', {
      text: '',
      expertise: 0,
      year: 0,
      lawyer: 0
    } as PublicationFilter);
    DataApi.instance.publicationEndpoint.distinctValues(this.settings)
      .then(response => {
        const template = require('../../handlebars/templates/publication/filter.handlebars');
        const html = template({
          distinctValues: response,
          filter: this.filter
        });
        this.update(html);
        this.initializeResult();
        ComponentRegistry.add('publication-filter', this);
      })
      .catch(e => {
        this.error(e);
      });
  }
}
